<template>
  <basicContainer>
    <avue-crud :data="data"
    :option="option"
    :page.sync="page"
    :search.sync="search"
    @search-change="searchChange"
    @row-save="rowSave"
    @row-update="rowUpdate"
    @row-del="rowDel"
    @on-load="onLoad">
  </avue-crud>
  </basicContainer>
</template>

<script>
import _ from 'lodash'
import api from './api'
export default {
  data() {
    return {
      count: 0,
      search: {},
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      data: [],
      option: {
        align: 'center',
        menuAlign: 'center',
        delBtn: false,
        column: [
          {
            label: '名称',
            prop: 'name',
            search: true,
            rules: [{
              required: true,
              message: '请输入名称'
            }]
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            value: 1,
            dicData: [{
              label: '正常',
              value: 1
            }, {
              label: '停用',
              value: 2
            }],
            rules: [{
              required: true,
              message: '请选择状态'
            }]
          },
          {
            label: 'id',
            prop: 'id',
            hide: true,
            addDisabled: true,
            addDisplay: false,
            search: false,
            editDisabled: true
          },
          {
            label: '联系人',
            prop: 'contactName',
            search: true
          },
          {
            label: '联系电话',
            prop: 'contactMobile',
            search: true
          },
          {
            label: 'corpid',
            prop: 'corpid',
            search: true
          }
        ]
      }
    }
  },
  computed: {
    queryWatch: function() {
      return {
        count: this.count,
        ...this.search,
        currentPage: this.page.currentPage,
        pageSize: this.page.pageSize
      }
    }
  },
  watch: {
    queryWatch(val, oldval) {
      if (!(_.isEqual(val, oldval))) {
        this.loadList(this.search)
      }
    }
  },
  mounted() {
    this.loadList({})
  },
  methods: {
    onLoad(page) {
      this.page = page
    },
    async loadList(postdata) {
      try {
        const { code, data } = await api.apiTenantQuery(postdata, 'id', {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize
        })

        if (code === 200) {
          const {
            records,
            total
          } = data
          this.data = records
          this.page.total = total
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    searchChange(params, done) {
      done()
      this.search = params
    },
    async rowSave(row, done, loading) {
      delete row.id
      row.status = parseInt(row.status)
      try {
        const { code, msg } = await api.apiTenantAdd([row])
        if (code === 200) {
          this.count += 1
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
      done()
    },
    async updateOne(row, done) {
      try {
        const { code, msg } = await api.apiTenantEdit(row)
        if (code === 200) {
          this.count += 1
          done()
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    rowUpdate(row, index, done, loading) {
      this.updateOne(row, done)
    },
    rowDel(row, index) {

    }
  }
}
</script>
